import useChromiumPingPong from '@hooks/useChromiumPingPong';
import React from 'react';

function PingPong() {
  useChromiumPingPong();
  return null;
}

export default React.memo(PingPong);
